export enum AppAction {
  INTERNAL_LINK = 'INTERNAL_LINK',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  INFO_MODAL = 'INFO_MODAL',
}
